import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntDepartment } from "../../../../models/handBooks/department";

import { useTranslation } from "react-i18next";
import { useDepartment } from "./useDepartments";
import { useLazyGetDepartmentListQuery } from "../../../../redux/api/handBooksApi/departmentsApi";
import { FilterDepartments } from "./FilterDepartments";
import { AddDepartmentModal } from "./AddDepartmentModal";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntDepartmentFilter } from "../../../../models/filters/departmentFilter";

enum FormField {
  name,
  governmentIds,
}

export const Departments = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const { t } = useTranslation();
  const [selectedDepartment, setSelectedDepartment] = useState<EntDepartment>(new EntDepartment());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddDepartment, onEditDepartment, onDeleteDepartment } = useDepartment(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetDepartmentListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntDepartment, EntDepartmentFilter>({
	initialFilter: new EntDepartmentFilter(),
	query: getData
  });

  const openAddModal = (item: EntDepartment) => {
	setSelectedDepartment(item);
	setShowModal(true);
  };

  const setEntityFromFields = (): EntDepartmentFilter => {
	let filt: EntDepartmentFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.governmentIds = form.getFieldValue(FormField.governmentIds) ?? null;
	filt.page = 1;
	return filt;
  };

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.governmentIds, value: null },
	]);
  };

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('titles.governments') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 5 }>
			  <Spin
				spinning={ fetching }
				style={ {
				  width: '100%',
				  height: '180px',
				  display: 'flex',
				  alignItems: 'center',
				  justifyContent: 'center',
				} }
			  />
			</th>
		  </tr>
		) : (
		  <></>
		) }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.government?.nameRu : item.government?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button
					  className="btn_edit"
					  onClick={ () => {
						openAddModal(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <EditOutlined/> }
					/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button
					  className="btn_edit"
					  danger
					  onClick={ () => {
						onDeleteDepartment(item)
					  } }
					  type="primary"
					  shape="circle"
					  icon={ <DeleteOutlined/> }
					/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.departments') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntDepartment())
		} }>
		  { t('handbooks.departments.add_department') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterDepartments onSearch={ searchHandleClick } onReset={ () => {
		  clearFields();
		  searchHandleClick();
		} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddDepartmentModal
		department={ selectedDepartment }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedDepartment.id !== null ? onEditDepartment : onAddDepartment }
	  />
	  { contextHolder }
	</>
  );
};
